// <s-cursor-glow> tracks a fine pointer and exposes its position as --glow-x / --glow-y for a CSS light pool.
class SCursorGlow extends HTMLElement {
  #controller;
  #frame = 0;

  connectedCallback() {
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!finePointer || reducedMotion) return;

    this.#controller = new AbortController();
    const { signal } = this.#controller;

    this.addEventListener('pointermove', (event) => {
      cancelAnimationFrame(this.#frame);
      this.#frame = requestAnimationFrame(() => {
        const rect = this.getBoundingClientRect();
        this.style.setProperty('--glow-x', `${event.clientX - rect.left}px`);
        this.style.setProperty('--glow-y', `${event.clientY - rect.top}px`);
        this.dataset.active = '';
      });
    }, { signal });

    this.addEventListener('pointerleave', () => {
      cancelAnimationFrame(this.#frame);
      delete this.dataset.active;
    }, { signal });
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.#frame);
    this.#controller?.abort();
  }
}

if (!customElements.get('s-cursor-glow')) customElements.define('s-cursor-glow', SCursorGlow);
